import { IconButton, Stack } from '@mui/material'
import Button                from '@mui/material/Button'
import { useEffect, useState } from 'react'
import ShortFormControl        from '../ui/components/short-form-control'
import { useTranslation }      from 'react-i18next'
import Iconify                 from '../ui/components/Iconify'

const ServiceBulkgateSync = ({ defaultItems, onChange }) => {

  const [items, setItems] = useState(defaultItems ?? [])
  const { t } = useTranslation()

  useEffect(() => {
    if (!!onChange) {
      onChange(items)
    }
  }, [items])

  const setItem = (index, prop, value) => {
    setItems(prev => {
      prev[index][prop] = value
      return [...prev]
    })
  }

  const handleInputChange = (index) => (prop) => (e) => {
    setItem(index, prop, e.target.value)
  }

  return <Stack direction={'column'} gap={2}>
    {items.map((it, index) => <Stack key={index} direction={'row'} gap={2}>
      <ShortFormControl name={'keyword'} title={t('Keyword')} value={it.keyword} handleChange={handleInputChange(index)} />
      <ShortFormControl name={'recipient'} title={t('Recipient')} value={it.recipient} handleChange={handleInputChange(index)} type="number" />
      <ShortFormControl name={'text'} title={t('Text SMS')} value={it.text} handleChange={handleInputChange(index)} />
      <Button size={'small'} color={'error'} onClick={() => {
        setItems((prev) => {
          prev.splice(index, 1)
          return [...prev]
        })
      }}>
        <Iconify icon={'material-symbols:delete'} />
      </Button>
    </Stack>)}
    <Stack>
      <Button variant={'outlined'} onClick={() => {
        setItems((prev) => {
          return [...prev, { keyword: '', recipient: '', text: '' }]
        })
      }}>{t('Add')}</Button>
    </Stack>
  </Stack>
}

export default ServiceBulkgateSync